import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import "./layout.css";
import poweredLogo from "../../assets/png/new_powered_gw.png";
import smallLogo from "../../assets/png/getworkBottomLogo.png";
import Logo from "../../assets/svg/partner-logo.svg";
import {
  ArrowRightOnRectangleIcon,
  UserPlusIcon,
} from "@heroicons/react/24/outline";
import SideBar from "./SideBar";
import {
  HomeIcon,
  BriefcaseIcon,
  Cog6ToothIcon,
  WalletIcon,
  LockClosedIcon,
} from "@heroicons/react/24/outline";
import axios from "axios";
import { BASE_URL } from "../../customHooks/config";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAtom, atom } from "jotai";
import Dialog from "../dialog/Dialog";
import { USER_DETAILS_UPDATE } from "../pages/setting/Setting";
import { USER_DETAILS_UPDATE_UPLOAD_DAILOG } from "../section/JobSection/UploadDialog";
import { USER_DETAILS_UPDATE_WELCOME_MSG } from "../card/dashboardCard/WelcomeMsg";
import profilePicture from "../../assets/png/profilePicture.png";

export const USER_DETAILS = atom({});

function Layout({ children }) {
  // const children = props.children;
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useAtom(USER_DETAILS);
  const [settingUpdate] = useAtom(USER_DETAILS_UPDATE);
  const [uploadDailog] = useAtom(USER_DETAILS_UPDATE_UPLOAD_DAILOG);
  const [welcomeMsg] = useAtom(USER_DETAILS_UPDATE_WELCOME_MSG);

  const [links, setLinks] = useState([]);

  const [sideBarLinks, setSideBarLinks] = useState([]);
  const { id } = useParams();

  const [routeValue, setRouteValue] = useState(Number(id) || 1);

  useEffect(() => {
    if (id < 4) setRouteValue(Number(id) || 1);
    else setRouteValue(1);
  }, [id]);

  useEffect(() => {
    if (userInfo) {
      setLinks(
        userInfo?.data?.sidebar?.map((response) => {
          return response?.name;
        })
      );
    }
  }, [userInfo, id]);

  useEffect(() => {
    if (links)
      setSideBarLinks(
        navLinks?.filter((response, index) => response.title === links[index])
      );
  }, [links, routeValue]);

  // const links =  userInfo?.data?.sidebar?.map((response)=>{
  //   return response?.name;
  // });
  // const sideBarLinks = navLinks?.filter((response,index) => response.title === links[index]);
  // const userInfo = userDetails?.data?.user_details;

  const handleLogOut = () => {
    axios
      .get(`${BASE_URL}vendor/logout/`, { withCredentials: true })
      .then((res) => {
        toast.success(res?.data?.data?.message);
        navigate("/");
      })
      .catch((err) => {
        toast.error(err?.data?.error);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || token === "undefined") {
      navigate("/");
      return;
    }
    axios
      .get(`${BASE_URL}vendor/dashboard/user_details/`, {
        withCredentials: true,
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        if (res?.data?.success) {
          setUserInfo(res?.data?.data);
        } else {
          toast.error(res?.data?.error);
          navigate("/");
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          localStorage.removeItem("token");
          localStorage.removeItem("loggedIn");
          navigate("/");
        } else {
          toast.error("Something went wrong. Please try again.");
        }
      });
  }, [settingUpdate, uploadDailog, welcomeMsg]);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const DialogActions = (btnColor) => {
    return (
      <>
        {" "}
        <div className="grid grid-cols-2 gap-4 px-8 py-7 mt-[-50px]">
          <div>
            <button
              onClick={handleClose}
              type="button"
              className="border border-[#6C757D] text-[#6C757D] text-sm  h-[45px] w-full rounded-md "
            >
              Cancel
            </button>
          </div>
          <div>
            <button
              type="button"
              onClick={handleLogOut}
              className="bg-black text-white text-sm  h-[45px] w-full rounded-md "
            >
              Log out
            </button>
          </div>
        </div>
      </>
    );
  };

  const navLinks = userInfo?.data?.user_details?.is_vendor_approved
    ? [
        {
          title: `Dashboard`,
          path: `/dashboard`,
          icon: <HomeIcon className="h-6" />,
        },
        {
          title: `Jobs`,
          path: `/all-jobs/${routeValue}`,
          icon: <BriefcaseIcon className="h-6" />,
        },
        {
          title: `Upload Candidates`,
          path: `/upload-candidate`,
          icon: <UserPlusIcon className="h-6" />,
        },
        {
          title: `My Earning`,
          path: `/my-earning`,
          icon: <WalletIcon className="h-6" />,
        },
        {
          title: `Settings`,
          path: `/settings`,
          icon: <Cog6ToothIcon className="h-6" />,
        },
      ]
    : [
        {
          title: `Dashboard`,
          // path: `/dashboard`,
          icon: <LockClosedIcon className="h-6" />,
        },
        {
          title: `Jobs`,
          path: `/all-jobs/4`,
          icon: <BriefcaseIcon className="h-6" />,
        },
        {
          title: `Upload Candidates`,
          // path: `/upload-candidate`,
          icon: <LockClosedIcon className="h-6" />,
        },
        {
          title: `My Earning`,
          // path: `/my-earning`,
          icon: <LockClosedIcon className="h-6" />,
        },
        {
          title: `Settings`,
          path: `/settings`,
          icon: <Cog6ToothIcon className="h-6" />,
        },
      ];

  return (
    <>
      <div className="fixed h-fit w-full flex hide-scrollbar ">
        <aside
          className="sidebar hover:transition-all hide-scrollbar"
          id="navbar"
          aria-label="Sidebar"
        >
          <div className="h-full  pb-4 overflow-y-auto overflow-x-hidden bg-white hide-scrollbar">
            <div className="flex  justify-center w-full h-[50px] mt-[5px]">
              <img src={Logo} alt="getwork-logo" />
            </div>
            <hr className=" h-[1px] mt-[5px] border-t-0 bg-[#B0B6BA] opacity-100 dark:opacity-50" />
            <div className="h-[85%] flex flex-col  justify-between ">
              <div className="mt-8">
                {sideBarLinks.map((item, index) => (
                  <SideBar items={item} key={index} />
                ))}
              </div>
              <div className=" w-full  flex justify-center">
                <button
                  className="  w-[100%]  z-20  bg-[#263238] text-white flex justify-between h-[50px] items-center rounded-[4px] pl-[13px]"
                  onClick={handleClickOpen}
                >
                  <div
                    style={{
                      display: "flex",
                      minWidth: "230px",
                      alignItems: "center",
                    }}
                  >
                    <ArrowRightOnRectangleIcon className="h-6  " />
                    <p className="ml-5 text-sm "> Log Out</p>
                  </div>
                </button>
              </div>
            </div>

            <div className="img-top">
              <img
                src={poweredLogo}
                className="open-img-sidebar"
                alt="getworkLogo"
              />
            </div>
            <div className="img-top-second">
              <img
                src={smallLogo}
                className="close-img-sidebar"
                alt="getworkLogo"
              />
            </div>
          </div>
        </aside>
        <div className=" relative right-div">
          <div className=" w-full flex flex-col">
            <nav className=" sticky top-0 z-50 w-full bg-white  h-[70px] border-[#CBD5E1] border-b-[1px] flex items-center">
              <div className=" w-[100%] flex justify-between items-center pl-9 pr-9  ">
                <div>
                  <h2 className=" text-xl text-black font-bold">
                    {window.location.pathname.includes("/dashboard")
                      ? "DashBoard"
                      : window.location.pathname.includes("/all-jobs/")
                      ? "Jobs"
                      : window.location.pathname.includes("/upload-candidate")
                      ? "Upload Candidates "
                      : window.location.pathname.includes("/my-earning")
                      ? "My Earning "
                      : window.location.pathname.includes("/settings")
                      ? "Settings"
                      : "Jobs"}
                  </h2>
                </div>

                <div className="flex items-center">
                  <div className="flex flex-col justify-start items-end  pr-2 ">
                    <p className="text-sm font-medium  font-['gilroy-semibold'] ">
                      {userInfo?.data?.user_details?.first_name}{" "}
                      {userInfo?.data?.user_details?.last_name}
                    </p>
                    <p className="text-sm font-bold text-[#767676]">
                      ₹ {userInfo?.data?.user_details?.withdrawable_amount}{" "}
                    </p>
                  </div>
                  <div>
                    <img
                      className="inline-block h-12 w-12 rounded-full ring-2 ring-white"
                      src={
                        userInfo?.data?.user_details?.profile_picture
                          ? userInfo?.data?.user_details?.profile_picture
                          : profilePicture
                      }
                      alt="use-img"
                    />
                  </div>
                </div>
              </div>
            </nav>
            <div className=" absolute p-9 pt-[94px] pb-0  main-box h-[100dvh] overflow-auto scrollbar-hide bg-[#f9fafb] ">
              <div className="p-0 h-[100%]">{children}</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Dialog
          visible={open}
          title={"Are you sure you want to Log out ?"}
          handleCloseDialog={handleClose}
          actionsPannel={DialogActions("bg-green")}
          size={"w-[380px]"}
          color={"bg-green"}
        />
      </div>
    </>
  );
}

export default Layout;
